import { render, staticRenderFns } from "./TrainingPlanVideo.vue?vue&type=template&id=65a915cb"
import script from "./TrainingPlanVideo.vue?vue&type=script&lang=ts"
export * from "./TrainingPlanVideo.vue?vue&type=script&lang=ts"
import style0 from "./TrainingPlanVideo.vue?vue&type=style&index=0&id=65a915cb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports